import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { ProductImage } from "components/ProductImage";
import type { ProductImages } from "stores/product";

type Props = {
  image: ProductImages[number];
  productName?: string;
};

export const ProductImageModal = NiceModal.create(
  ({ image, productName = "" }: Props) => {
    const modal = NiceModal.useModal();

    return (
      <Modal
        isOpen={modal.visible}
        centered={true}
        toggle={modal.hide}
        scrollable={true}
        size="xl"
      >
        <ModalHeader toggle={modal.hide} tag="div" className="pb-0" />
        <ModalBody
          className="d-flex justify-content-center align-items-center m-0 pt-2_5"
          style={{ height: "68vh" }}
        >
          <ProductImage
            pimId={image?.pimId ?? null}
            width={800}
            height={600}
            productName={productName}
          />
        </ModalBody>
      </Modal>
    );
  },
);
